<ng-container *ngIf="this.airlineList && this.airlineList.length > 0">
  <div
    class="relative bg-white !mx-auto max-w-[792px] suggested-for-you !p-4 border border-palette-gray-200 shadow-sm rounded-xl">


    <p class="text-palette-gray-900  font-inter text-lg !font-semibold !pb-4">
      {{ 'CROSS_SALE.SUGGESTED_FOR_YOU' | translate }}
    </p>
    <app-carousel [items]="airlineList" [itemsToShow]="4" [itemsToScroll]="1" [gap]="12" [itemTemplate]="customTemplate"
      [id]="'suggested-card'"
      [breakpoints]="[{ width: 1200, itemsToShow: 4 }, { width: 1000, itemsToShow: 3 }, { width: 540, itemsToShow: 2 }, { width: 0, itemsToShow: 1 }]">
    </app-carousel>
    <ng-template #customTemplate let-item let-index="index">
      <div class="airline-suggested flex flex-col !h-[335px] " style="
        border: #eaecf0;
        border-style: solid;
        border-width: thin;
        border-radius: 8px;
        background-color: white;
      " (click)="cardClickHandle(item.one_way_trip[0]?.segments[0].operating.operating_code ?? '')">
        <div
          style="height: calc(100% - 165px); width: 100%; min-height: calc(100% - 165px); max-height: calc(100% - 165px)">
          <img [src]="
            item.one_way_trip[0]?.flight_route_image
              ? getImagePath(item.one_way_trip[0]?.flight_route_image)
              : defaultImage
          " style="height: 100%; width: 100%; object-fit: cover; border-radius: 8px 8px 0px 0px" [alt]="''"
            (error)="getDefaultImage($event)" />
        </div>

        <div class="t-content flex flex-col !p-4 bg-white gap-2 justify-between"
          style="height: 100%; border-radius: 0 0 8px 8px">
          <div class="flex flex-col gap-1">

            <!-- title  -->
            <div class="relative">
              <p class="t-titile height-10 line-clamp-2"
                style="color: #101828; line-height: 20px; font-size: 14px; font-weight: 500; font: Inter" [tooltip]="item.one_way_trip[0]?.segments[0]?.origin?.city_name + ' (' +
              item.one_way_trip[0]?.segments[0]?.origin?.city_code + ') → '
              + item.one_way_trip[0]?.segments[item.one_way_trip[0]?.segments?.length - 1]?.destination?.city_name + ' (' +
              item.one_way_trip[0]?.segments[item.one_way_trip[0]?.segments?.length - 1]?.destination?.city_code + ')'" [isTruncated]="true">
                {{item.one_way_trip[0]?.segments[0]?.origin?.city_name + ' (' +
                item.one_way_trip[0]?.segments[0]?.origin?.city_code + ') → '
                + item.one_way_trip[0]?.segments[item.one_way_trip[0]?.segments?.length - 1]?.destination?.city_name + ' (' +
                item.one_way_trip[0]?.segments[item.one_way_trip[0]?.segments?.length - 1]?.destination?.city_code + ')'}}
              </p>
            </div>

            <!-- Description -->
            <ng-container>

              <div class="items-center flex line-clamp-1">
                <div [pTooltip]="item.one_way_trip[0]?.segments[0].operating.operating_name ?? ''"
                  tooltipPosition="top">
                  <img *ngIf="item.one_way_trip[0]?.segments[0].operating.operating_image_id" loading="lazy"
                    class="!h-4 !w-4 object-cover rounded"
                    [src]="getImagePath(item.one_way_trip[0]?.segments[0].operating.operating_image_id)"
                    (error)="replaceWithDefaultImage($event)" alt="">
                  <img *ngIf="!item.one_way_trip[0]?.segments[0].operating.operating_image_id" loading="lazy"
                    class="!h-4 !w-4 object-cover rounded"
                    [src]="getImagePath(item.one_way_trip[0]?.segments[0].operating.operating_image_url)"
                    (error)="replaceWithDefaultImage($event)" alt="">
                </div>
                <p style="
                  color: #667085;
                  font-size: 12px;
                  line-height: 16px;
                  font-weight: 400;
                  font: Inter;
                  padding-left: 4px;
                " class="line-clamp-1">
                  | {{cabinClass}}
                </p>
              </div>

            </ng-container>
          </div>
          <!-- price and button -->
          <div>
            <div class="t-price flex flex-row gap-1 items-baseline" style="height: 28px"
              *ngIf="item.one_way_trip[0]?.class_info[0]?.total_price && item.one_way_trip[0]?.class_info[0]?.total_price >= 0">
              <p class="t-price" style="color: #e04f16; font-size: 18px; font-weight: 600; line-height: 28px">
                {{ item.one_way_trip[0]?.class_info[0]?.total_price ?? 0 | currencyConversion }}
              </p>
            </div>
            <button class="btn-book-now" style="
              color: #1570ef;
              line-height: 20px;
              font-size: 14px;
              font-weight: 500;
              white-space: nowrap;
              width: 100%;
              background-color: #eff8ff;
              height: 28px;
              padding: 4px 8px 4px 8px;
              border-radius: 8px;
            ">
              {{
              'CROSS_SALE.BOOKING_NOW' | translate

              }}
            </button>
          </div>
        </div>
      </div>

    </ng-template>
  </div>
</ng-container>